import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';

import { EuiChipComponent } from './eui-chip.component';
import { EuiIconModule } from '../atoms';
import { EuiTooltipDirectiveModule } from '../../directives';

@NgModule({
    imports: [
        CommonModule,
        MatChipsModule,
        EuiIconModule,
        EuiTooltipDirectiveModule,
    ],
    declarations: [
        EuiChipComponent,
    ],
    exports: [
        EuiChipComponent,
    ],
})
export class EuiChipModule { }
